export default {
  title: `
    Unlock Your Coding Potential <br /> with SkillSynergy's Live Courses!
  `,
  meeting: "Schedule a Free Consultation",
};
